import types from 'constants/CompanyConstants';
import Immutable from 'immutable';

const initialState = Immutable.fromJS([]);

export default function(state = initialState, action) {
	switch (action.type) {
		case types.REFRESH_COMPANY_LIST:
      return Immutable.fromJS(action.companyList)

    case types.UPDATE_COMPANY_NAME:
      let idx = state.findIndex((company) => company.get('id') === action.id)
      return state.setIn([idx, 'name'], action.name)
                  .setIn([idx, 'ownerName'], action.ownerName)
                  .setIn([idx, 'contact'], action.contact)
                  .setIn([idx, 'address'], action.address)

    case types.DELETE_COMPANY:
      return state.delete(
        state.findIndex((company) => company.get('id') === action.id),
      )

    case types.ADD_COMPANY:
      return state.push(Immutable.fromJS({
        id: action.id,
        name: action.name,
        ownerName: action.ownerName,
        contact: action.contact, 
        address: action.address
      }))

		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/reducers/Company.js